// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".page-title[data-v-3057cfeb] {\n  font-size: 24px;\n  color: #253342 !important;\n  font-weight: 700 !important;\n}", ""]);
// Exports
module.exports = exports;
